import { jsx as e, jsxs as f, Fragment as C } from "react/jsx-runtime";
import { IconNames as p } from "@blueprintjs/icons";
import { MessagingBlock as E } from "@strata/react-messaging-block";
import { Icon as m, Badge as R } from "@strata/react-status-icons";
import { CountUpTimer as x } from "@strata/react-timers";
import O from "classnames";
import { useRef as U, useState as N, useEffect as D, createElement as W } from "react";
import F from "react-animate-height";
import "./main.scss";
import { Icon as M, MenuDivider as z, MenuItem as H } from "@blueprintjs/core";
import { AllNotificationsDialog as b } from "@strata/react-dialog";
import { DropdownMenu as B } from "@strata/react-dropdown-menu";
const h = {
  SUCCESS: "success",
  WARNING: "warning",
  CAUTION: "caution",
  INFO: "info"
}, G = {
  [h.SUCCESS]: m.Intent.SUCCESS,
  [h.WARNING]: m.Intent.WARNING,
  [h.CAUTION]: m.Intent.ERROR,
  [h.INFO]: m.Intent.INFO
}, A = {
  NEW: "NEW",
  SEEN: "SEEN",
  INTERACTED: "INTERACTED",
  DELETED: "DELETED"
}, g = ({
  type: t,
  status: r,
  icon: o = void 0,
  notificationTitle: i,
  bodyText: a,
  additionalData: n = void 0,
  timestamp: d,
  onNotificationClick: s,
  onRemoveNotificationClick: c = void 0,
  lapsed: l = !1
}) => {
  const u = U(null), [I, v] = N(0);
  D(() => {
    u.current && v(u.current.clientHeight);
  }, []);
  const [_, w] = N(!1), T = (S) => {
    w(!0), S.stopPropagation();
  };
  return /* @__PURE__ */ e(
    F,
    {
      duration: 300,
      height: _ ? 0 : "auto",
      onHeightAnimationEnd: c,
      animateOpacity: !0,
      ref: u,
      children: /* @__PURE__ */ f(
        "div",
        {
          className: O("sds_notification", {
            "sds_notification--lapsed": l
          }),
          children: [
            /* @__PURE__ */ e(
              "div",
              {
                className: r === A.NEW ? "sds_notification--not-seen" : "sds_notification--seen"
              }
            ),
            /* @__PURE__ */ f(
              "div",
              {
                className: O("sds_notification__container", {
                  [`sds_notification__type--${t}`]: t,
                  "sds_notification__container--viewed": r === A.INTERACTED,
                  "sds_notification__container--lapsed": l
                }),
                onClick: s,
                onKeyDown: (S) => {
                  S.key === "Enter" && s(S);
                },
                role: "button",
                tabIndex: 0,
                children: [
                  l && /* @__PURE__ */ f("div", { className: "sds_notification__lapsed-overlay", children: [
                    /* @__PURE__ */ e(
                      E,
                      {
                        size: E.Sizes.SMALL,
                        icon: I >= 100 ? p.TIME : void 0,
                        primaryText: "Notification lapsed.",
                        secondaryText: "This notification is no longer relevant."
                      }
                    ),
                    /* @__PURE__ */ e(
                      m,
                      {
                        className: "sds_notification__lapsed-overlay__remove-button",
                        icon: p.SMALL_CROSS,
                        intent: m.Intent.SECONDARY,
                        onClick: T,
                        title: "Remove"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ f("div", { className: "sds_notification__header-row", children: [
                    o && /* @__PURE__ */ e(
                      m,
                      {
                        icon: o,
                        size: 14,
                        intent: G[t]
                      }
                    ),
                    /* @__PURE__ */ e(
                      "span",
                      {
                        className: O("sds_notification__header-row__title", {
                          [`sds_notification__header-row__title--${t}`]: t
                        }),
                        children: i
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: "sds_notification__header-row__elapsed-time", children: /* @__PURE__ */ e(x, { startTime: d }) }),
                    /* @__PURE__ */ e(
                      m,
                      {
                        className: "sds_notification__header-row__remove-button",
                        icon: p.SMALL_CROSS,
                        intent: m.Intent.SECONDARY,
                        onClick: T,
                        title: "Remove"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e("div", { className: "sds_notification__body-row", children: a }),
                  n && /* @__PURE__ */ e("div", { className: "sds_notification__additional-data", children: n })
                ]
              }
            )
          ]
        }
      )
    }
  );
};
g.Types = h;
g.Statuses = A;
function L({
  notification: t,
  NotificationComponentMap: r,
  onNotificationClick: o,
  onRemoveNotificationClick: i
}) {
  const { id: a, type: n, ...d } = t, s = r == null ? void 0 : r[n];
  return s ? /* @__PURE__ */ W(
    s,
    {
      ...d,
      key: a,
      onNotificationClick: () => {
        o(a);
      },
      onRemoveNotificationClick: () => {
        i == null || i(a);
      }
    }
  ) : null;
}
const y = 5, P = ({
  onDismiss: t,
  children: r
}) => {
  const [o, i] = N(!1), [a, n] = N(!1);
  return D(() => {
    let d, s;
    return a || (d = setTimeout(() => i(!0), y * 1e3), s = setTimeout(() => t(), (y + 0.5) * 1e3)), () => {
      clearTimeout(d), clearTimeout(s);
    };
  }, [a, t]), /* @__PURE__ */ e(
    "div",
    {
      className: O("sds_incoming-notifications__popover", {
        "sds_incoming-notifications__popover--slide-out": o
      }),
      onMouseEnter: () => n(!0),
      onMouseLeave: () => n(!1),
      children: r
    }
  );
}, $ = ({
  incomingNotification: t = void 0,
  NotificationComponentMap: r = void 0,
  onNotificationClick: o = void 0
}) => {
  const [i, a] = N([]);
  return D(() => {
    const n = (s) => {
      a((c) => c.filter((l) => l.id !== s));
    }, d = (s) => {
      const c = L({
        notification: {
          ...s,
          small: !0,
          status: g.Statuses.SEEN
          // Don't show unread dot for popover notifications
        },
        NotificationComponentMap: r,
        onNotificationClick: (l) => {
          o == null || o(l), n(l);
        },
        onRemoveNotificationClick: n
      });
      return c ? /* @__PURE__ */ e(
        P,
        {
          onDismiss: () => n(s.id),
          children: c
        },
        s.id
      ) : null;
    };
    t && a(
      (s) => s.find((c) => c.id === t.id) ? s : [
        {
          id: t.id,
          component: d(t)
        },
        ...s
      ]
    );
  }, [t, r, o]), /* @__PURE__ */ e("div", { className: "sds_incoming-notifications", children: i.map((n) => n.component) });
}, j = 5, ne = ({
  notifications: t = [],
  incomingNotification: r,
  NotificationComponentMap: o,
  onNotificationClick: i,
  onRemoveNotificationClick: a = void 0,
  onClearAllNotificationsClick: n,
  onNotificationsDropdownClose: d = void 0
}) => {
  var v;
  const [s, c] = N(!1), [l, u] = N(!1), I = (_, w = !1) => (_ == null ? void 0 : _.map(
    (T) => L({
      notification: { ...T, small: w },
      NotificationComponentMap: o,
      onNotificationClick: (S) => {
        i == null || i(S), c(!1), u(!1);
      },
      onRemoveNotificationClick: a
    })
  )) ?? [];
  return /* @__PURE__ */ f(C, { children: [
    /* @__PURE__ */ e(
      B,
      {
        isOpen: s,
        onInteraction: (_) => c(_),
        onClosed: d,
        menuContent: /* @__PURE__ */ f(C, { children: [
          t.length > 0 ? /* @__PURE__ */ e("div", { className: "sds_notifications-dropdown__list", children: I(
            t.slice(0, j),
            !0
          ) }) : /* @__PURE__ */ e(
            E,
            {
              size: E.Sizes.SMALL,
              icon: p.TICK_CIRCLE,
              iconStatus: E.Status.SUCCESS,
              primaryText: "All caught up!",
              secondaryText: "No new notifications to show.",
              className: "sds_notifications-dropdown__no-notifications"
            }
          ),
          /* @__PURE__ */ e(z, {}),
          /* @__PURE__ */ e(
            H,
            {
              text: "View All Notifications",
              onClick: () => u(!0)
            }
          )
        ] }),
        children: /* @__PURE__ */ f("div", { className: "sds_notifications-dropdown", children: [
          /* @__PURE__ */ e(
            M,
            {
              icon: p.NOTIFICATIONS,
              title: "Notifications",
              size: 20,
              style: { cursor: "pointer" }
            }
          ),
          /* @__PURE__ */ e("div", { style: { position: "relative" }, children: /* @__PURE__ */ e(
            R,
            {
              intent: R.Intent.UNREAD,
              count: (v = t == null ? void 0 : t.filter(
                (_) => _.status === g.Statuses.NEW
              )) == null ? void 0 : v.length
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ e(
      $,
      {
        incomingNotification: r,
        NotificationComponentMap: o,
        onNotificationClick: i
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        notifications: I(t),
        isOpen: l,
        onClose: () => u(!1),
        onClearAllNotificationsClick: n
      }
    )
  ] });
};
export {
  g as BaseNotification,
  ne as NotificationsDropdownMenu
};
//# sourceMappingURL=index.js.map
